import { type ComponentPropsWithoutRef, lazy } from "react";

export type DialogCloseProps = ComponentPropsWithoutRef<typeof DialogClose>;

export const DialogClose = lazy(async () => {
	const Dialog = await import("@radix-ui/react-dialog");

	return { default: Dialog.Close };
});

export type DialogTitleProps = ComponentPropsWithoutRef<typeof DialogTitle>;

export const DialogTitle = lazy(async () => {
	const Dialog = await import("@radix-ui/react-dialog");

	return { default: Dialog.Title };
});

export type DialogDescriptionProps = ComponentPropsWithoutRef<typeof DialogDescription>;

export const DialogDescription = lazy(async () => {
	const Dialog = await import("@radix-ui/react-dialog");

	return { default: Dialog.Description };
});

export { Boundary as DialogBoundary, type BoundaryProps as DialogBoundaryProps } from "./boundary";
export { Dialog, type DialogProps } from "./dialog";
export { Trigger as DialogTrigger, type TriggerProps as DialogTriggerProps } from "./trigger";

// hooks

export { useDialogClose } from "./context";
